/**
 * While the session and the person load (canvas 03-boot): the system flow's
 * `BootScreen` — the boot mark, the app's name, and what is being waited for.
 *
 * Wrapped so it fills whatever holds it: the whole window at the gate, or the
 * room beside the rail when a record's own layout waits for its catalogue.
 */
import type { ReactElement } from 'react';

import { BootScreen } from '~/features/system/boot-screen';

export function BootSplash(): ReactElement {
  return (
    <div className="flex h-full min-w-0 flex-1 flex-col">
      <BootScreen />
    </div>
  );
}
